import { jsx as _jsx } from "react/jsx-runtime";
const AssigneeOptionContainer = ({
  children
}) => /*#__PURE__*/_jsx("div", {
  className: "p-x-5 p-y-2",
  children: children
});
AssigneeOptionContainer.displayName = 'AssigneeOptionContainer';
export default AssigneeOptionContainer;